<div class="wms-typeahead-container event-handler" [attr.name]="name"  [ngClass]="ngClass">
    <input #typeaheadInput type="text"
        [placeholder]="placeholder"
        spellcheck="false"
        class ="form-control app-textbox typeahead-input "
        attr.name="{{name}}-typeahead-field"
         id="typeahead-{{typeaheadUid}}"
        [name]="name"
        autocomplete="off"
        [(ngModel)]="typeaheadModel"
        (typeaheadOnSelect)="handleOnSelect($event)"
        container="{{appendToBody ? 'body': 'document'}}"
        [typeahead]="filteredOptions$"
        [typeaheadOptionField]="propertyName"
        [typeaheadGroupField]="groupBy"
        [optionsListTemplate]="customTypeaheadList"
        [disabled]="disable"
        [contentEditable]="editable || false"
        [typeaheadWaitMs]="0"
        [typeaheadMinLength]="0"
        [adaptivePosition]="true"
        (focus)="typeaheadFocus($event)"
        (ngModelChange)="onModelChange(typeaheadModel)"
        [typeaheadOptionsLimit]="1000"
        [ngModelOptions]="{ updateOn: updateValueOn}">
    <button type="button" *ngIf="showActionButtons" #expandBtn [disabled]="disable" (click)="inputRef?.nativeElement?.click()" class="wms-typeahead-icon wms wms-arrow-down typeahead-expand-btn" title="{{locale.LABEL_EXPAND.toLowerCase()}}"></button>
    <button type="button" *ngIf="showActionButtons" [hidden]="!typeaheadModel || typeaheadInput.getAttribute('focus')" [ngClass]="{'ng-hide': !typeaheadInput.getAttribute('focus')}" #clearBtn (click)="handleClear($event)" [disabled]="disable" class="wms-typeahead-icon wms wms-clear typeahead-clear-btn" title="{{locale.LABEL_CLEAR.toLowerCase()}}"></button>
<div>
<ng-template #customTypeaheadList let-matches="matches" let-index="index" let-typeaheadTemplateMethods>
    <ul role="listbox" class="wms-typeahead-dropdown" [ngClass]="dropdownClass">
        <li class="uib-typeahead-match" *ngFor="let match of matches; index as i" [ngClass]="{'active': typeaheadTemplateMethods.isActive(match)}">
            <div [ngClass]="{'typeahead-group-header': match?.isHeader()}" *ngIf="match.isHeader()">{{match.value}}</div>
            <a *ngIf="!match.isHeader()" (click)="typeaheadTemplateMethods.selectMatch(match, $event)"(mouseenter)="typeaheadTemplateMethods.selectActive(match)">
                    <span [title]="match.value" [innerHtml]="highlight(match, typeaheadModel) || match.value"></span>
                <!-- Color Preview (if colorHex exists) -->
                <div *ngIf="match.item.colorHex" class="color-preview" [style.background]="match.item.colorHex"></div>
                 <button *ngIf="itemTrailingIconClass" class="wms" [ngClass]="itemTrailingIconClass" (click)="onItemIconClick(match);$event.stopPropagation();"></button>
            </a>
        </li>
        <li *ngIf="createNewLabel">
            <button  class="btn btn-link btn-group-justified" (click)="handleCreateNew()">
             {{ createNewLabel }}
            </button>
        </li>
    </ul>
</ng-template>
